var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"mb-lg pb-lg"},[_c('General')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }